<template>
	<div class="main">
		<Steps :index="1" :product-name="info.productName" />
		<ApplicantInfo v-if="info.applicantList!=null" :info="info.applicantList[0]" :insuredList="info.insuredList[0]"
			:premium="info.premium" :productCode="info.productCode" title="投保企业信息" />
		<InsuredPersonInfo v-if="info.productCode=='CCIC_EMPLOYER_LIABILITY_M1'" :info="info" />
		<RecognizeInfo :info="info" class="mt20" />
		<InvoiceInfo v-if="info.invoiceInfo!=null" :info="info.invoiceInfo" />
		<!-- 核保中 -->
		<div v-if="applicationStatus=='REVIEWING'">
			<div class="mt20 center">
				<p>
					<Button type="primary" disabled>核保中</Button>
				</p>
				<div class="mt20">
					<p class="red">正在核保中，请耐心等待</p>
					1、如您在等待过程中需关闭此页面，则该投保单可以在【用户中心-我的投保单】中将投保单状态选择为“核保中”，进行查看。<br />
					2、如核保通过，则进入【用户中心-我的订单-选择待支付订单】进行后续支付流程即可。
				</div>
			</div>
		</div>
		<!-- 核保失败 -->
		<div v-if="applicationStatus=='REVIEWED_REJECTED'">
			<div class="mt20 center">
				<p class="mt10">实际支付：<span class="price">{{info.premium}}元</span></p>
				<p class="mt10 center red font14">
					失败原因：{{ info.remark }}
				</p>
				<p class="mt10">
					<a class="font14" @click="goLink">返回编辑页面</a>
				</p>
			</div>
		</div>
		<!-- 大地低职业 meng -->
		<div v-if="info.productCode=='CCIC_EMPLOYER_LIABILITY_M1'||info.productCode=='CCIC_EMPLOYER_LIABILITY_M2'">
			<!-- 待确认 -->
			<div v-if="applicationStatus=='UNCONFIRMED'">
				<sunshineUpload :info="info" ref="insurance" :multiple="true" />
				<div class="mt15 agree flex">
					<Checkbox v-model="agree">我已经阅读并同意</Checkbox>
					<div v-if="info.productCode=='CCIC_EMPLOYER_LIABILITY_M2'">
						<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/CCIC_EMPLOYER_LIABILITY_M2/%E4%B8%AD%E5%9B%BD%E5%A4%A7%E5%9C%B0%E8%B4%A2%E4%BA%A7%E4%BF%9D%E9%99%A9%E8%82%A1%E4%BB%BD%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%E9%9B%87%E4%B8%BB%E8%B4%A3%E4%BB%BB%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE%EF%BC%882014%E7%89%88%EF%BC%89.doc" target="_blank" referrerpolicy="no-referrer">《中国大地财产保险股份有限公司雇主责任保险条款（2014版）》</a><br />
						<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/CCIC_EMPLOYER_LIABILITY_M2/%E9%99%84%E5%8A%A024%E5%B0%8F%E6%97%B6%E6%89%A9%E5%B1%95%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE.docx" target="_blank" referrerpolicy="no-referrer">《附加24小时扩展保险条款》</a><br />
						<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/CCIC_EMPLOYER_LIABILITY_M2/%E9%99%84%E5%8A%A0%E4%BC%A4%E6%AE%8B%E7%AD%89%E7%BA%A7%E8%B5%94%E5%81%BF%E6%AF%94%E4%BE%8B%E8%A1%A8%E8%B0%83%E6%95%B4%E4%BF%9D%E9%99%A9A.docx" target="_blank" referrerpolicy="no-referrer">《附加伤残等级赔偿比例表调整保险A》</a><br />
						<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/CCIC_EMPLOYER_LIABILITY_M2/%E9%99%84%E5%8A%A0%E8%AF%AF%E5%B7%A5%E8%B4%B9%E7%94%A8%E8%B5%94%E5%81%BF%E8%AE%A1%E7%AE%97%E6%A0%87%E5%87%86%E8%B0%83%E6%95%B4%E6%9D%A1%E6%AC%BE.docx" target="_blank" referrerpolicy="no-referrer">《附加误工费用赔偿计算标准调整条款》</a>
					</div>
					<div v-if="info.productCode=='CCIC_EMPLOYER_LIABILITY_M1'">
						<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/CCIC_EMPLOYER_LIABILITY_M1/%E4%B8%AD%E5%9B%BD%E5%A4%A7%E5%9C%B0%E8%B4%A2%E4%BA%A7%E4%BF%9D%E9%99%A9%E8%82%A1%E4%BB%BD%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%E9%9B%87%E4%B8%BB%E8%B4%A3%E4%BB%BB%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE%EF%BC%882014%E7%89%88%EF%BC%89.doc" target="_blank" referrerpolicy="no-referrer">《中国大地财产保险股份有限公司雇主责任保险条款（2014版）》</a><br />
						<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/CCIC_EMPLOYER_LIABILITY_M1/%E9%99%84%E5%8A%A024%E5%B0%8F%E6%97%B6%E6%89%A9%E5%B1%95%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE.docx" target="_blank" referrerpolicy="no-referrer">《附加24小时扩展保险条款》</a><br />
						<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/CCIC_EMPLOYER_LIABILITY_M1/%E9%99%84%E5%8A%A0%E4%BC%A4%E6%AE%8B%E7%AD%89%E7%BA%A7%E8%B5%94%E5%81%BF%E6%AF%94%E4%BE%8B%E8%A1%A8%E8%B0%83%E6%95%B4%E4%BF%9D%E9%99%A9A.docx" target="_blank" referrerpolicy="no-referrer">《附加伤残等级赔偿比例表调整保险A》</a><br />
						<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/CCIC_EMPLOYER_LIABILITY_M1/%E9%99%84%E5%8A%A0%E8%AF%AF%E5%B7%A5%E8%B4%B9%E7%94%A8%E8%B5%94%E5%81%BF%E8%AE%A1%E7%AE%97%E6%A0%87%E5%87%86%E8%B0%83%E6%95%B4%E6%9D%A1%E6%AC%BE.pdf" target="_blank" referrerpolicy="no-referrer">《附加误工费用赔偿计算标准调整条款》</a>
					</div>
				</div>
				<div class="mt20 center">
					<p>实际支付：<span class="price">{{info.premium}}元</span></p>
					<p class="mt10">
						<Button type="primary" @click="toPayDadi" :loading="loading">立即支付</Button>
					</p>
				</div>
			</div>
		</div>
		<Modal v-model="agreementShow" width="700" title="提示">
			<div>
				<div class="flex" v-if="!agree">
					我已经阅读并同意
					<div v-if="info.productCode=='CCIC_EMPLOYER_LIABILITY_M2'">
						<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/CCIC_EMPLOYER_LIABILITY_M2/%E4%B8%AD%E5%9B%BD%E5%A4%A7%E5%9C%B0%E8%B4%A2%E4%BA%A7%E4%BF%9D%E9%99%A9%E8%82%A1%E4%BB%BD%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%E9%9B%87%E4%B8%BB%E8%B4%A3%E4%BB%BB%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE%EF%BC%882014%E7%89%88%EF%BC%89.doc" target="_blank" referrerpolicy="no-referrer">《中国大地财产保险股份有限公司雇主责任保险条款（2014版）》</a><br />
						<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/CCIC_EMPLOYER_LIABILITY_M2/%E9%99%84%E5%8A%A024%E5%B0%8F%E6%97%B6%E6%89%A9%E5%B1%95%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE.docx" target="_blank" referrerpolicy="no-referrer">《附加24小时扩展保险条款》</a><br />
						<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/CCIC_EMPLOYER_LIABILITY_M2/%E9%99%84%E5%8A%A0%E4%BC%A4%E6%AE%8B%E7%AD%89%E7%BA%A7%E8%B5%94%E5%81%BF%E6%AF%94%E4%BE%8B%E8%A1%A8%E8%B0%83%E6%95%B4%E4%BF%9D%E9%99%A9A.docx" target="_blank" referrerpolicy="no-referrer">《附加伤残等级赔偿比例表调整保险A》</a><br />
						<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/CCIC_EMPLOYER_LIABILITY_M2/%E9%99%84%E5%8A%A0%E8%AF%AF%E5%B7%A5%E8%B4%B9%E7%94%A8%E8%B5%94%E5%81%BF%E8%AE%A1%E7%AE%97%E6%A0%87%E5%87%86%E8%B0%83%E6%95%B4%E6%9D%A1%E6%AC%BE.pdf" target="_blank" referrerpolicy="no-referrer">《附加误工费用赔偿计算标准调整条款》</a>
					</div>
					<div v-if="info.productCode=='CCIC_EMPLOYER_LIABILITY_M1'">
						<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/CCIC_EMPLOYER_LIABILITY_M1/%E4%B8%AD%E5%9B%BD%E5%A4%A7%E5%9C%B0%E8%B4%A2%E4%BA%A7%E4%BF%9D%E9%99%A9%E8%82%A1%E4%BB%BD%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%E9%9B%87%E4%B8%BB%E8%B4%A3%E4%BB%BB%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE%EF%BC%882014%E7%89%88%EF%BC%89.doc" target="_blank" referrerpolicy="no-referrer">《中国大地财产保险股份有限公司雇主责任保险条款（2014版）》</a><br />
						<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/CCIC_EMPLOYER_LIABILITY_M1/%E9%99%84%E5%8A%A024%E5%B0%8F%E6%97%B6%E6%89%A9%E5%B1%95%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE.docx" target="_blank" referrerpolicy="no-referrer">《附加24小时扩展保险条款》</a><br />
						<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/CCIC_EMPLOYER_LIABILITY_M1/%E9%99%84%E5%8A%A0%E4%BC%A4%E6%AE%8B%E7%AD%89%E7%BA%A7%E8%B5%94%E5%81%BF%E6%AF%94%E4%BE%8B%E8%A1%A8%E8%B0%83%E6%95%B4%E4%BF%9D%E9%99%A9A.docx" target="_blank" referrerpolicy="no-referrer">《附加伤残等级赔偿比例表调整保险A》</a><br />
						<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/CCIC_EMPLOYER_LIABILITY_M1/%E9%99%84%E5%8A%A0%E8%AF%AF%E5%B7%A5%E8%B4%B9%E7%94%A8%E8%B5%94%E5%81%BF%E8%AE%A1%E7%AE%97%E6%A0%87%E5%87%86%E8%B0%83%E6%95%B4%E6%9D%A1%E6%AC%BE.pdf" target="_blank" referrerpolicy="no-referrer">《附加误工费用赔偿计算标准调整条款》</a>
					</div>
				</div><br />
				<p>我已知晓：本方案生效日期最早为保费缴纳后次日零时</p>
			</div>
			<template slot="footer">
				<Button type="text" @click="agreementShow=false">取消</Button>
				<Button type="primary" :loading="loading" @click="agreementOk">同意并继续</Button>
			</template>
		</Modal>
	</div>
</template>
<script>
import RecognizeInfo from './RecognizeInfo'
import ApplicantInfo from './common/ApplicantInfo'
import InsuredPersonInfo from './common/InsuredPersonInfo'
import InvoiceInfo from './common/InvoiceInfo'
import Steps from './common/Steps'
import InsuranceSlip from './common/InsuranceSlip'
import personListUpload from './common/personListUpload'
import sunshineUpload from './common/sunshineUpload'

import track from "@/mixin/track";
export default {
	components:{ RecognizeInfo,ApplicantInfo,InvoiceInfo,Steps,InsuranceSlip,personListUpload,sunshineUpload,InsuredPersonInfo },
	mixins:[track],
	data () {
		return {
			info:{
				id:this.$route.params.id,
			},
			loading:false,
			agree:false,
			id:this.$route.params.id,
			applicationStatus:'',
			timer:null,
			agreementShow:false
		}
	},
	created(){
		if(this.id){
			this.getInfo();
		}
	},
	mounted () {
		// 回溯 开始录制
		this.$nextTick(this.startRecord);
	},
	beforeDestroy() {
		//在 beforeDestroy生命周期函数中销毁定时器
		clearInterval(this.timer);
		this.timer = null;
	},
	beforeRouteLeave (to, from, next) {
		this.agreementShow = false;
		this.$nextTick(()=>{
			next();
		})
	},
	methods:{
		// 同意协议
		agreementOk(){
			this.toPay()
		},
		goLink(){
			clearInterval(this.timer)
			this.$router.push({
				path:`/companyGroupEmployerDadi/fillin/${this.info.applicationNo}?productCode=${this.info.productCode}&productName=${this.info.productName}&reset=NEW&newPremium=${this.info.premium}`
			})
		},
		// 根据id获取信息
		getInfo(){
			this.$axios.post('/broker/insurance/application/detail',{
				applicationId: this.id
			}).then(res=>{
				this.info = res;
				this.applicationStatus = res.applicationStatus;
				if(res.applicationStatus=='REVIEWING'||res.applicationStatus=='CONFIRMED'){
					this.timer = setInterval(() => {
						this.getSatus()
					}, 5000)
				}
			});
		},
		getSatus(){
			setTimeout(()=>{
				this.$axios.post('/broker/insurance/application/detail',{
					applicationId: this.id
				}).then(res=>{
					this.applicationStatus = res.applicationStatus;
					this.info.premium = res.premium;
					this.info.remark = res.remark;
					if((res.applicationStatus =='UNCONFIRMED'||res.applicationStatus =='QUOTE_REJECTED'||res.applicationStatus =='REVIEWED_REJECTED'||res.applicationStatus =='REJECTED')||res.applicationStatus =='REVIEWED_REJECTED'){
						clearInterval(this.timer);
						this.agreementShow = false;
					}
					if(res.applicationStatus=='CONFIRMED'){
						// 调获取订单号接口
						this.$axios.post('/broker/order/list.json',{
							bizId:'INDUSTRY_ENTERPRISE',
							applicationNo: this.info.applicationNo,
							count:10,
							page:1
						}).then(async res=>{
							// 回溯 停止录制
							await this.stopRecord({
								policy_id:this.info.applicationNo
							});
							clearInterval(this.timer)
							window.location.href=`/common.html#/payCCIC?orderNo=${res[0].orderNo}&productCode=${this.info.productCode}`
						})
					}
				});
          	}, 0)
		},
		async toPayDadi(){
			if(this.agree){
				this.toPay()
			} else {
				this.agreementShow = true;
			}
		},
		// 大地支付
		async toPay () {
			/*获取投保单*/
			let insuranceForm = await this.$refs.insurance.val();
			if(!insuranceForm){
			    this.toast('请上传投保单','error');
				return
			}
			this.loading=true;
			this.$axios.post('/broker/attachment/uploadAttachmentFile.json.all',{
				bizId: this.info.bizId,
				productCode: this.info.productCode,
				applicationId: this.id,
				fileList: insuranceForm.fileList
			}).then(res=>{
				if(res.code==10000000){
					this.$axios.post('/broker/insurance/application/confirm.all',{
						applicationId: this.id
					}).then(async res=>{
						if(res.code==10000000){
							if(!res.data){
								setTimeout(()=>{
									this.loading = false
								},5000)
								this.timer = setInterval(() => {
									this.getSatus()
								}, 5000)
							} else {
								// 回溯 停止录制
								await this.stopRecord({
									policy_id:this.info.applicationNo
								});
								window.location.href=`/common.html#/payCCIC?orderNo=${res.data}&productCode=${this.info.productCode}`
							}
						}else{
							this.loading = false;
							this.alert(res.msg);
						}
						
					}).catch(err=>{
						this.loading=false;
					});
				}
			}).catch(err=>{
				this.loading=false;
			})
		}
	}
}
</script>
<style scoped lang="less">
	.font-weight{
		font-weight: bold;
	}
	.main{
		background: #fff;
		margin-top: 24px;
		padding :30px 40px;
	}
	.mt20{
	    line-height: 1.8;
	}
	span.price{
	    color:#FF0000;
	    font-weight: bold;
	}
	.font14{
		font-size: 16px;
	}
	.font20 {
		font-size: 24px;
	}
	.flex {
		display: flex;
		align-items: flex-start;
		justify-content: left;
	}
</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/Confirm.vue